// Ramblin Trades Coffee Co. — slide-out cart drawer
class RTCartDrawer {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.overlay = document.querySelector('[data-cart-overlay]');
    this.openTriggers = document.querySelectorAll('[data-cart-open]');
    this.closeTriggers = document.querySelectorAll('[data-cart-close]');
    this.itemsWrap = document.querySelector('[data-cart-items]');
    this.subtotalEl = document.querySelector('[data-cart-subtotal]');
    this.countEls = document.querySelectorAll('[data-cart-count]');
    this.shippingBarFill = document.querySelector('[data-shipping-bar-fill]');
    this.shippingBarLabel = document.querySelector('[data-shipping-bar-label]');
    this.threshold = parseFloat(this.drawer ? this.drawer.dataset.freeShippingThreshold : 50) || 50;

    this.bindEvents();
    this.bindAddToCartForms();
  }

  bindEvents() {
    this.openTriggers.forEach((el) => el.addEventListener('click', (e) => { e.preventDefault(); this.open(); }));
    this.closeTriggers.forEach((el) => el.addEventListener('click', () => this.close()));
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
  }

  // Intercept any form[action="/cart/add"] on the page (product forms, quick-add cards)
  bindAddToCartForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.addItem(new FormData(form));
      });
    });
  }

  async addItem(formData) {
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
      if (!res.ok) throw new Error('Add to cart failed');
      await this.refresh();
      this.open();
    } catch (err) {
      console.error('[Ramblin Trades] Add to cart error:', err);
    }
  }

  async refresh() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    this.render(cart);
  }

  render(cart) {
    this.countEls.forEach((el) => { el.textContent = cart.item_count; });
    if (this.subtotalEl) this.subtotalEl.textContent = this.formatMoney(cart.total_price);

    if (this.itemsWrap) {
      if (cart.item_count === 0) {
        this.itemsWrap.innerHTML = '<p class="rt-cart-empty">Your bag is empty. Time to gear up.</p>';
      } else {
        this.itemsWrap.innerHTML = cart.items.map((item) => `
          <div class="rt-cart-line" data-line-key="${item.key}">
            <img src="${item.image}" alt="${item.product_title}">
            <div class="rt-cart-line__info">
              <p class="rt-cart-line__title">${item.product_title}</p>
              <p class="rt-cart-line__variant">${item.variant_title || ''}</p>
              <p class="rt-cart-line__price">${this.formatMoney(item.final_line_price)}</p>
            </div>
          </div>
        `).join('');
      }
    }

    if (this.shippingBarFill && this.shippingBarLabel) {
      const remaining = Math.max(0, this.threshold - cart.total_price / 100);
      const pct = Math.min(100, (cart.total_price / 100 / this.threshold) * 100);
      this.shippingBarFill.style.width = pct + '%';
      this.shippingBarLabel.textContent = remaining > 0
        ? `Add $${remaining.toFixed(2)} more for free shipping`
        : "You've earned free shipping";
    }
  }

  formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  open() {
    if (this.drawer) this.drawer.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.refresh();
  }

  close() {
    if (this.drawer) this.drawer.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', () => { window.rtCartDrawer = new RTCartDrawer(); });
